import { useGetComments, useGetLogs, usePostComments } from "../../mutations";

export const useCommentsAndLogs = ({ topic, sub_event, object_id, parent_id }: { topic: string[]; sub_event: string[]; object_id: string | undefined; parent_id: string | undefined; }) => {

    const log = useGetLogs();
    const comments = useGetComments();
    const postComments = usePostComments();

    const getLogs = async () => {
        const params = {
            topic: topic,
            sub_event: sub_event,
            object_id: object_id,
            parent_id: parent_id
        }
        await log.mutateAsync(params);
    };

    const getComments = async () => {
        const params = {
            object_type: sub_event,
            comment_topic: topic,
            object_id: object_id,
            parent_id: parent_id
        }
        await comments.mutateAsync(params);
    };
    
    const postComment = async (comment: string) => {
        const payload: any = {
            ...(parent_id !== "" && { parent_id }),
            comment_topic: topic[0],
            object_id,
            object_type: sub_event[0],
            comment_text: comment,
        };
        await postComments.mutateAsync(payload);
        await getComments();
    };

    return {
        getLogs,
        getComments,
        postComment,
        isCommentsPending: comments.isPending,
        isLogsPending: log.isPending,
        comments: comments.isSuccess ? comments.data.data.rows : [],
        logs: log.isSuccess ? log.data.data.rows : [],
        isAddingComment : postComments.isPending
    };

};